// @flow

import React, { type AbstractComponent, type ElementProps } from 'react';

declare type StyleFactory<T> = (props: any) => $PropertyType<ElementProps<T>, 'style'>;

export function componentFactory<T: string>(TagName: T, styleFactory: StyleFactory<T>): AbstractComponent<ElementProps<T>, HTMLElement> {
  const render = ({ children, ...props }, ref) => {
    return React.cloneElement(<TagName ref={ref} style={styleFactory(props)} />, props, children);
  };

  return React.forwardRef(render);
}
